import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './analytics'; // Import for gtag type declaration

/**
 * Hook to track page views in Google Analytics for React Router SPAs.
 * Call this once in your App component.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-FJZJSH0NDJ', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

